export const TeamPageLoadingSkeleton = () => {
  return (
    <div className="min-h-screen w-full animate-pulse bg-[#f2f2f2]">
      <div className="w-full bg-[#dcdbee]">
        <div className="mx-auto grid w-full max-w-[1920px] gap-0 md:grid-cols-[1fr_410px]">
          <div className="px-6 pb-6 pt-8 md:px-10">
            <div className="h-12 w-72 rounded-md bg-[#cbc9df]" />
            <div className="mt-6 flex gap-6">
              <div className="h-14 w-24 rounded-md bg-[#cbc9df]" />
              <div className="h-14 w-24 rounded-md bg-[#cbc9df]" />
              <div className="h-14 w-24 rounded-md bg-[#cbc9df]" />
            </div>
            <div className="mt-8 h-6 w-[60%] rounded-md bg-[#cbc9df]" />
          </div>
          <div className="border-l border-[#d1d0e2] bg-[#e9e8f2] px-5 pb-5 pt-8">
            <div className="h-10 w-56 rounded-md bg-[#d7d5e8]" />
            <div className="mt-5 h-12 w-full rounded-md bg-[#d7d5e8]" />
            <div className="mt-4 grid grid-cols-2 gap-3">
              <div className="h-10 rounded-md bg-[#d7d5e8]" />
              <div className="h-10 rounded-md bg-[#d7d5e8]" />
            </div>
            <div className="mt-4 h-10 w-full rounded-md bg-[#d7d5e8]" />
          </div>
        </div>
      </div>
      <div className="mx-auto grid w-full max-w-[1920px] md:grid-cols-[1fr_410px]">
        <div className="relative min-h-[58vh] bg-[#4fc2a8]">
          <div className="absolute inset-0 bg-gradient-to-b from-[#62ccb5] via-[#4fc2a8] to-[#46baa0]" />
          <div className="relative flex flex-col items-center px-6 pt-16 md:px-10">
            <div className="h-8 w-[70%] max-w-[720px] rounded-md bg-[#8cd8ca]/60" />
            <div className="mt-8 grid w-full max-w-[720px] grid-cols-3 gap-4 md:grid-cols-4">
              {Array.from({ length: 11 }).map((_, index) => (
                <div key={index} className="h-16 rounded-md bg-[#9fdfd2]/60" />
              ))}
            </div>
            <div className="mt-10 h-12 w-80 rounded-lg bg-[#9fdfd2]/60" />
          </div>
        </div>
        <div className="border-l border-[#d9d9df] bg-[#efeff4] px-5 pb-6 pt-4">
          <div className="h-[58vh] rounded-lg border border-[#e3e3ea] bg-[#f6f6fa] p-3">
            <div className="h-6 w-24 rounded bg-[#dfdeeb]" />
            <div className="mt-4 space-y-3">
              {Array.from({ length: 7 }).map((_, index) => (
                <div key={index} className="h-12 rounded-md bg-[#e7e6f1]" />
              ))}
            </div>
          </div>
          <div className="mt-4 h-32 rounded-lg border border-[#e1e1e8] bg-[#f6f6fa]" />
        </div>
      </div>
    </div>
  );
};
